export var FindingObjectType;
(function (FindingObjectType) {
    FindingObjectType["FINDING_OBJECT_TYPE_PATH"] = "PATH";
    FindingObjectType["FINDING_OBJECT_TYPE_TABLE"] = "TABLE";
    FindingObjectType["FINDING_OBJECT_TYPE_DATABASE"] = "DATABASE";
    FindingObjectType["FINDING_OBJECT_TYPE_KMS_KEY"] = "KMS_KEY";
})(FindingObjectType || (FindingObjectType = {}));
